module.exports = __webpack_public_path__ + "img/your_word_attack_hard.0b93c387.jpg";